<template>
  <div id="scroll">
    <div class="container">
      <el-form ref="ruleForm" :model="ruleForm" label-width="80px">
        <!-- <el-form-item label="体系类别" prop="type">
          <el-input v-model="ruleForm.type"></el-input>
        </el-form-item> -->
         <el-form-item label="体系类别">
          <el-select v-model="ruleForm.type" placeholder="请选择体系类别">
            <el-option
              v-for="item in BusinessList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="ruleForm.sort"></el-input>
        </el-form-item>
        <el-form-item>
          <el-upload
            class="upload-demo"
            :before-upload="beforeUpload"
            :http-request="upload"
            ref="upload"
            action=""
            :limit="1"
            :accept="'.jpg,.jpeg,.png,.JPG,.JPEG'"
            :on-exceed="overSize"
          >
            <el-button size="small" type="primary"
              >{{ isEdit ? "编辑" : "上传" }}未选中的标识</el-button
            >
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-upload
            class="upload-demo"
            :before-upload="beforeUpload2"
            :http-request="upload2"
            ref="upload2"
            action=""
            :limit="1"
            :accept="'.jpg,.png,.JPG,'"
            :on-exceed="overSize"
          >
            <el-button size="small" type="primary"
              >{{ isEdit ? "编辑" : "上传" }}选中的标识</el-button
            >
          </el-upload>
        </el-form-item>
      </el-form>

      <div class="editWrap">
        <editor-vue
          class="editor"
          :value="ruleForm.text"
          @input="(res) => (ruleForm.text = res)"
        >
        </editor-vue>
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addNew()">确 定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  addSysProduct,
  editSysProduct,
  uploadIllustration,
  editIcon,
  listProductType
} from "@/api/manage";
import editorVue from "@/components/txtModule/richText.vue";
export default {
  data() {
    return {
      ruleForm: {
        type: "",
        title: "",
        text: "",
        sort:'',
         picIs: "", //上传选中图片标识
         picNs: "", //上传未选中图片标识
      },
      BusinessList:[],
      isEdit: false,
      val: "",
      isEdit: false,
      editId: "",
      BusinessList: [],
       newFile: new FormData(),
       newFile2: new FormData(),
    };
  },
  components: {
    editorVue,
  },
  created() {
    this.getlistProductType()
    this.isEdit = this.$route.params.typeOf == "edit";
    this.editId = this.$route.params.id || "";
    this.ruleForm.type = this.$route.params.type || "";
    this.ruleForm.title = this.$route.params.title || "";
    console.log('this.$route',this.$route.params.sort,this.$route.params.total,this.$route.params);
    this.ruleForm.sort = this.$route.params.sort || this.$route.params.total+1
    // this.ruleForm.picIs = this.$route.params.picIs
    // this.ruleForm.picNs = this.$route.params.picNs
    this.ruleForm.text = this.$route.params.text
      ? decodeURI(this.$route.params.text)
      : "";
  },
  methods: {
    async getlistProductType(){
       let res = await listProductType({ pageNo: 1, pageSize: 999})
       res.data.map(item=>{
         let obj ={}
         obj.name=item.typeName
         obj.id=item.id
         this.BusinessList.push(obj)
       })
       console.log('res',res);
    },
    async addNew() {
      //确认新增
      if (!this.isEdit) {
        //新增
        if (this.ruleForm.text.length == 0) {
          return this.$message.error("内容不能为空！");
        } else if (this.ruleForm.type == "") {
          return this.$message.error("体系类别不能为空！");
        } 
        // if (this.ruleForm.title == "") {
        //   return this.$message.error("标题不能为空！");
        // } 
        else if (this.ruleForm.picNs == ""&&this.ruleForm.picIs != "") {
          return this.$message.error("未选中标题与已选中标识必须同时上传");
        } else if (this.ruleForm.picNs != ""&&this.ruleForm.picIs == "") {
          return this.$message.error("未选中标题与已选中标识必须同时上传");
        }
       // 必填项不能为空，否则不能上传
        this.ruleForm.text = encodeURI(this.ruleForm.text + "");
        let res = await addSysProduct(this.ruleForm);
        if (res.code == 200) {
          this.$message.success("新增产品体系成功！");
          this.ruleForm.text = "";
          this.ruleForm.title = "";
          this.ruleForm.type = "";
           this.ruleForm.picNs = "";
           this.ruleForm.picIs = "";
          this.$router.replace("/itemSystem");
        }
      } else {
        //编辑状态
        let param = {};
        if (this.ruleForm.picNs == ""&&this.ruleForm.picIs != "") {
          return this.$message.error("请上传未选中标识");
        } else if (this.ruleForm.picNs != ""&&this.ruleForm.picIs == "") {
          return this.$message.error("请上传选中标识");
        }
        param.id = this.editId;
        param.text = encodeURI(this.ruleForm.text + "");
        // console.log(12345,decodeURI(param.text));
        param.type = this.ruleForm.type;
        param.title = this.ruleForm.title;
        param.sort = this.ruleForm.sort
        param.picNs=this.ruleForm.picNs
        param.picIs=this.ruleForm.picIs
        let res = await editSysProduct(param);
        if (res.code == 200) {
          this.$message.success("编辑成功！");
          this.$router.replace("/itemSystem");
        }
      }
    },
    cancel() {
      this.$router.replace("/itemSystem");
    },
    beforeUpload(file) {
      //文件上传之前的钩子
      let name = file.name.split('.')
      if (file) {
        let arr=['image/jp2','image/jepg','image/png','image/jpeg']
        let type=name[name.length-1]
        let arr2=['jpg','png']
        console.log('arr2',arr2.includes(type));
        if(arr.includes(file.type)&&arr2.includes(type)){
         this.newFile.append("file", file);
        }else{
          this.$message.error('插图只能上传jpg/png格式文件！')
          return false
        }
      } else {
        return false;
      }
    },
    beforeUpload2(file) {
      //文件上传之前的钩子
      let name = file.name.split('.')
      if (file) {
         let arr=['image/jp2','image/jepg','image/png','image/jpeg']
          let type=name[name.length-1]
        let arr2=['jpg','png']
        console.log('arr2',arr2.includes(type));
        if(arr.includes(file.type)&&arr2.includes(type)){
         this.newFile2.append("file", file);
        }else{
          this.$message.error('插图只能上传jpg/png格式文件！')
          return false
        }
      } else {
        return false;
      }
    },
    async upload() {
      //文件上传时的钩子
       let res = await uploadIllustration(this.newFile);
      if (res.code == 200) {
        this.ruleForm.picNs = res.data.id;
      //   if(this.isEdit){
      //   console.log('正在编辑');
      //   let param ={}
      //   param.id = this.editId+''
      //   param.picId = res.data.id+''
      //   param.type=2+''
      //   console.log('param',param);
      //   let res2 = await editIcon(param)
      //   return this.$message.success("编辑未选中标识成功！");
      // }
        this.$message.success("未选中标识上传成功！");
      }
    },
    async upload2() {
      //文件上传时的钩子
      let res = await uploadIllustration(this.newFile2);
      if (res.code == 200) {
        this.ruleForm.picIs = res.data.id;
      //    if(this.isEdit){
      //   console.log('正在编辑');
      //   let param ={}
      //   param.id = this.editId+''
      //   param.picId = res.data.id+''
      //   param.type=1+''
      //   console.log('param',param);
      //   let res2 = await editIcon(param)
      //   return this.$message.success("编辑选中标识成功！");
      // }
        this.$message.success("选中标识上传成功！");
      }
     // console.log('123',this.isEdit);
     
    },
    overSize(){
      this.$message.error('标识最多只能上传一张！')
    }
  },
  computed: {
  	leaveDataNew() {
        return JSON.parse(JSON.stringify(this.ruleForm.sort))//watch监听要求
  	},
 },
  watch: {
    leaveDataNew:{
      handler:function(newVal,oldVal){
        var reg = /^[+]{0,1}(\d+)$/
          if (!reg.test(newVal)&&newVal!='') {
            this.ruleForm.sort = oldVal
          } else {
            this.ruleForm.sort = newVal
          }
      },
      deep:true
    }
  }
};
</script>

<style lang="less" scoped>
#scroll {
  height: 100%;
}
.container {
  padding: 30px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.el-form {
  display: flex;
  flex-wrap: wrap;
}
.el-form .el-input {
  width: 215px;
}
</style>